import React, { PureComponent, lazy, Suspense } from "react";

const JobPublish = lazy(() => import("pages/userCenter/recruitEnterprise/jobPublish"));
const EnterpriseInfo = lazy(() => import("pages/userCenter/recruitEnterprise/enterpriseInfo"));
const JobDetail = lazy(() => import("pages/userCenter/recruitEnterprise/jobDetail"));
const ResumeSearch = lazy(() => import("pages/userCenter/recruitEnterprise/resumeSearch"));
const ResumeDetail = lazy(() => import("pages/userCenter/recruitEnterprise/resumeDetail"))
const ResumeReceived = lazy(() => import("pages/userCenter/recruitEnterprise/resumeReceived"))
const TalentReserve = lazy(() => import("pages/userCenter/recruitEnterprise/talentReserve"))
const SigningManage = lazy(() => import("pages/userCenter/recruitEnterprise/signingManage"))


export const userRouter = [
    {
        title: "企业信息管理",
        component: EnterpriseInfo,
        path: "/entrance/recruitEnterprise/enterpriseInfo",
    },
    {
        title: "职位发布",
        component: JobPublish,
        path: "/entrance/recruitEnterprise/jobPublish",
    },
    {
        path: '/entrance/recruitEnterprise/jobPublish/jobDetail/:id?',
        title: '职位详情',
        component: JobDetail
    },
    {
        title: "简历搜索",
        component: ResumeSearch,
        path: "/entrance/recruitEnterprise/resumeSearch",
    },
    {
        title: "简历详情",
        component: ResumeDetail,
        path: "/entrance/recruitEnterprise/resumeSearch/resumeDetail/:id?",
    },
    {
        title: "收到的简历",
        component: ResumeReceived,
        path: "/entrance/recruitEnterprise/resumeReceived",
    },
    {
        title: "简历详情",
        component: ResumeDetail,
        path: "/entrance/recruitEnterprise/resumeReceived/resumeDetail/:id?",
    },
    {
        title: "人才储备库",
        component: TalentReserve,
        path: "/entrance/recruitEnterprise/talentReserve",
    },
    {
        title: "简历详情",
        component: ResumeDetail,
        path: "/entrance/recruitEnterprise/talentReserve/resumeDetail/:id?",
    },
    {
        title: "简历签约管理",
        component: SigningManage,
        path: "/entrance/recruitEnterprise/signingManage",
    },
    {
        title: "简历详情",
        component: ResumeDetail,
        path: "/entrance/recruitEnterprise/signingManage/resumeDetail/:id?",
    }

];

export const navRouter = [
    {
        title: "企业信息管理",
        component: EnterpriseInfo,
        path: "/entrance/recruitEnterprise/enterpriseInfo",
    },
    {
        title: "职位发布",
        component: JobPublish,
        path: "/entrance/recruitEnterprise/jobPublish",
    },
    {
        title: "简历搜索",
        component: ResumeSearch,
        path: "/entrance/recruitEnterprise/resumeSearch",
    },
    {
        title: "收到的简历",
        component: ResumeReceived,
        path: "/entrance/recruitEnterprise/resumeReceived",
    }, {
        title: "人才储备库",
        component: TalentReserve,
        path: "/entrance/recruitEnterprise/talentReserve",
    }, {
        title: "简历签约管理",
        component: SigningManage,
        path: "/entrance/recruitEnterprise/signingManage",
    }
];